import type { Template } from "@/types";

export const LA_01_H1_V0: Template[] = [
    {
        id: "la-01-h1v0-01",
        name: "LA 01 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 756, y: 77, width: 516, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-02-h1v0-01",
        name: "LA 02 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 80, y: 77, width: 516, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v0-01",
        name: "LA 03 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 676, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v0-01",
        name: "LA 04 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v0-01",
        name: "LA 05 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 496, y: 43, width: 807, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v0-01",
        name: "LA 06 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 49, y: 43, width: 807, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v0-01",
        name: "LA 07 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 237, y: 48, width: 878, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-08-h1v0-01",
        name: "LA 08 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 45, width: 1267, height: 440, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-09-h1v0-01",
        name: "LA 09 - H1V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-01-h1_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1352, height: 531, rotation: 0, imageRotation: 0 }
        ],
    }
];